<!-- 客户端绑定管理 -->
<template>
  <div class="tableShow">
    <Table
      ref="table"
      :loadObj="{}"
      :dict="[]"
      :option="{}"
      :colObj="{
        opId: '20023',
        col: [],
      }"
    >
    </Table>
  </div>
</template>

<script>
import Table from "@/components/table/dataTablec";
import {post} from '@/api/table/table'
export default {
  components: {
    Table,
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    // 审核
    approveRowClick(btn,row){
      this.$confirm("确定审核该数据?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        post('/api/blade-xfjd/system/clientBind/verify',this.$qs.stringify({
          id:row.ID,
          dataVer:row.DATA_VER,
          runId:this.$route.query.runId
        })).then(res=>{
          this.$message.success("审核成功!");
        },err=>{})
      },err=>{});
    },
    // 撤销
    repealRowClick(btn,row){
      this.$confirm("确定撤销该数据?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        post('/api/blade-xfjd/system/clientBind/cancel',this.$qs.stringify({
          id:row.ID,
          dataVer:row.DATA_VER,
          runId:this.$route.query.runId,
        })).then(res=>{
          this.$message.success("撤销成功!");
        },err=>{})
      },err=>{});
    },
    // 恢复
    regainRowClick(btn,row){
      this.$confirm("确定撤销该数据?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        post('/api/blade-xfjd/system/clientBind/recover',this.$qs.stringify({
          id:row.ID,
          dataVer:row.DATA_VER,
          runId:this.$route.query.runId,
        })).then(res=>{
          this.$message.success("撤销成功!");
        },err=>{})
      },err=>{});
    }
  },
  created() {},
  mounted() {},
  activated() {},
};
</script>

<style></style>
